import { useEffect, useState } from "react";
import type { Attachment } from "@/api/attachment";
import {
  attachmentMeasureUrl,
  attachmentPixelLabel,
} from "@/lib/cms-puck/media-utils";

/**
 * Affiche `W × H px` sous une vignette : d'abord depuis `details` (stocké à
 * l'upload), sinon en mesurant l'image (large/original) côté client.
 */
export function AttachmentPixelSize({
  att,
  className = "line-clamp-1 w-full text-center text-[10px] text-slate-400",
}: {
  att: Attachment;
  className?: string;
}) {
  const stored = attachmentPixelLabel(att);
  const [measured, setMeasured] = useState<string | null>(null);
  const measureUrl = stored ? undefined : attachmentMeasureUrl(att);

  useEffect(() => {
    if (stored || !measureUrl) {
      setMeasured(null);
      return;
    }
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (cancelled) return;
      if (img.naturalWidth > 0 && img.naturalHeight > 0) {
        setMeasured(`${img.naturalWidth} × ${img.naturalHeight} px`);
      }
    };
    img.onerror = () => {
      if (!cancelled) setMeasured(null);
    };
    img.src = measureUrl;
    return () => {
      cancelled = true;
    };
  }, [stored, measureUrl]);

  const label = stored ?? measured;
  if (!label) return null;
  return <span className={className}>{label}</span>;
}
